<template>
  <div class="course-categories-field row no-gutters">
    <div class="col-12">
      <Field
        class="d-inline-block mr-3 mb-2"
        type="select"
        label="Category"
        name="category_id"
        v-model="category"
        :options="categories"
        :hideSelectEmptyOption="true"
      />
      <Field
        class="d-inline-block mr-3 mb-2"
        type="text"
        label="Hours"
        name="category_hours"
        v-model="hours"
      />
      <button type="button" class="btn btn-info" @click.prevent="add">
        Attach
      </button>
    </div>
    <div v-if="assigned.length > 0" class="col-12 mt-3 multi-assign-values">
      <a
        v-for="(item, i) in assigned"
        :key="i"
        class="pill"
        href="#"
        @click.prevent="remove(item)"
      >
        <span class="text">{{ itemLabel(item) }}</span>
        <icon icon="remove" class="icon" />
        <input
          type="hidden"
          :name="`categories[${item.category_id}][hours]`"
          :value="item.hours"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
    categories: { type: Array, required: true },
  },
  data() {
    return {
      category: null,
      hours: 0.0,
      assigned: [],
    };
  },
  watch: {
    value(val) {
      this.assigned = val;
    },
    assigned(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    itemLabel(item) {
      var category = this.categories.find((c) => c.value == item.category_id);
      return `${category.label} - ${item.hours} hr(s)`;
    },
    isAssigned(item) {
      return (
        this.assigned.find((a) => a.category_id == item.category_id) || false
      );
    },
    add() {
      if (!this.category || `${this.hours}`.length == 0) {
        alert(
          "Please choose a category and enter the credit hours before continuing."
        );
        return;
      }
      var item = {
        category_id: this.category,
        hours: this.hours,
      };
      if (this.isAssigned(item)) {
        alert("You have already assigned the selected category.");
        return;
      }
      this.assigned.push(item);
      this.reset();
    },
    remove(item) {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter((a) => {
        return a.category_id != item.category_id;
      });
    },
    reset() {
      this.category = null;
      this.hours = 0.0;
    },
  },
  mounted() {
    this.assigned = this.value;
  },
};
</script>